var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01297 2.51041L9.03952 4.58048C9.17952 4.86864 9.5528 5.14504 9.8678 5.19797L11.7284 5.50965C12.9183 5.70961 13.1983 6.57998 12.3408 7.43859L10.8944 8.89704C10.6494 9.14403 10.5152 9.62038 10.591 9.96151L11.0052 11.7669C11.3318 13.196 10.5793 13.7488 9.32536 13.0019L7.58137 11.961C7.26642 11.7728 6.74732 11.7728 6.42648 11.961L4.68253 13.0019C3.43433 13.7488 2.67609 13.1901 3.00272 11.7669L3.41684 9.96151C3.49266 9.62038 3.35851 9.14403 3.11353 8.89704L1.66703 7.43859C0.815458 6.57998 1.0896 5.70961 2.27946 5.50965L4.14009 5.19797C4.44922 5.14504 4.82251 4.86864 4.9625 4.58048L5.98904 2.51041C6.54898 1.38716 7.45887 1.38716 8.01297 2.51041Z",
    fill: "#1E40AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5e122e89864e96595ff16362a2299a69.svg";
export { ForwardRef as ReactComponent };